import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { QuestsModel,QuestsCategoryModel, QuestsStatusModel } from "../Api/Models/quests.model";
import { QuestsService } from "../Api/Services/QuestsService";
import { HomeIcon } from "../Components/Icons/HomeIcon";
import { getCachedQuestCategories, setCachedQuestCategories } from "../Utils/questCache";



const Quests: React.FunctionComponent<object> = () => {
    const { t } = useTranslation();
    const [quests, setQuests] = useState<QuestsModel[]>([]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const result = await new QuestsService().getQuests();
                setQuests(result);
            } catch (error) {
                console.error("Quests fetched with error:", error);
            }
        };

        fetchData();
    }, []);

    const [questCategories,setquestCategories] = useState<QuestsCategoryModel[]>([]);

    useEffect(() => {
        const fetchQuestCategories = async () => {
            try {
                const cached = getCachedQuestCategories();
                if (cached) {
                    setquestCategories(cached);
                    return;
                }

                const result = await new QuestsService().getQuestCategories();
                setquestCategories(result);
                setCachedQuestCategories(result);
            } catch (error) {
                console.error("❌ Error fetching quest categories:", error);
            }
        };

        fetchQuestCategories();
    }, []);

    const questStatus: QuestsStatusModel[] = [
        { id: 1, name: t("New"), color: "new" },
        { id: 2, name: t("Denied"), color: "refused" },
        { id: 3, name: t("Approved") , color: "approved" },
        { id: 4, name: t("WIP"), color: "wip" },
        { id: 5, name: t("Completed"), color: "approved" },
    ]

    const [selectedCategory, setSelectedCategory] = useState<number>(-1);
    const [selectedStatus, setSelectedStatus] = useState<number>(-1);

    const filteredQuests = quests.filter((quest) => {
        const matchCategory = selectedCategory === -1 || quest.questCategory === selectedCategory;
        const matchStatus = selectedStatus === -1 || quest.status === selectedStatus;
        return matchCategory && matchStatus;
    });

    return (

        <div className="view-container background-white">
            <div className="view-content">

                <div className="navigationbar navigationbar--dark mb-6">
                    <div className="navigationbar__left">
                        <Link to="/menu" className="navigationbar__button">
                            <HomeIcon/>
                        </Link>
                    </div>
                    <div className="navigationbar__center">
                        <div className="navigationbar__title">{t("Quests")}</div>
                    </div>
                    <div className="navigationbar__right">
                    </div>
                </div>
                <div>

                    <div className="flex justify-between mb-2 items-center gap-2">
                        <div className="select-minimal-wrapper mr-2">
                            <select
                                dir="rtl"
                                value={selectedCategory}
                                onChange={(e) => setSelectedCategory(Number(e.target.value))}
                            >
                                <option value={-1}>{t("All")}</option>
                                {questCategories.map((category) => (
                                    <option key={category.id} value={category.id}>
                                        {category.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="select-minimal-wrapper mr-2">
                            <select
                                dir="rtl"
                                value={selectedStatus}
                                onChange={(e) => setSelectedStatus(Number(e.target.value))}
                            >
                                <option value={-1}>{t("All")}</option>
                                {questStatus.map((status) => (
                                    <option key={status.id} value={status.id}>
                                        {status.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <div className="card-list mb-12">
                        {filteredQuests.map((quest, index) => (
                            <Link
                                key={index}
                                to={`/quest/view/${quest.id}`}
                                state={{ quest }}
                                className="order-list-card"
                            >
                                <div className="stock-list-card m" key={index}>
                                    <div className="stock-list-card__top">

                                        <div className="flex gap-2 justify-between items-center">
                                            <div className="flex gap-2">
                                                <div className="flex items-center">
                                                    <div className="stock-list-card__pc">
                                                        {quest.name}
                                                    </div>
                                                </div>

                                            </div>
                                        </div>

                                        <div className="separator-line separator-line--p10"></div>

                                        <div className="flex justify-between gap-2">
                                            <div className="flex gap-1 items-center">
                                                <div className="text-secondary">
                                                    <strong>{t("Date")}:</strong> {new Date(quest.startDate).toLocaleDateString()}
                                                    <br/>
                                                    <strong>{t("Category")}:</strong> {questCategories.find(category => category.id === quest.questCategory)?.name || t("Unknown Category")}
                                                </div>
                                            </div>
                                            <div>
                                                <p>
                                                    {questStatus.find(status => status.id === quest.status)?.name || t("Unknown Status")}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </Link>
                        ))}
                    </div>
                </div>
                <div className="flex justify-center mt-4">
                <Link to="/quest/newquest" className="button px-6">
                    {t("Create Quest")}
                </Link>
                </div>
                <div className="flex justify-center mt-4">
                    <Link to="/menu" className="button px-6">
                        <i className="icon-arrow-left button__icon button__icon--prefix"></i>
                        {t("Back")}
                    </Link>
                </div>

            </div>
        </div>
    );
};

export default Quests;
